import { combineReducers } from 'redux';
import { createRouterReducer } from '@lagunovsky/redux-react-router';
import { browserHistory } from 'src/history/history';
import { InfoUserState } from './features/users/infoUser/types';
import infoUser from './features/users/infoUser';
import { IInitKeycloakState } from './features/initilizationKeycloak/types';
import initilizationKeycloak from './features/initilizationKeycloak';
import { AllModalsState } from './features/methodModels/allModels/types';
import allModels from './features/methodModels/allModels';
import editModels from './features/methodModels/editModels';
import { EditModelsState } from './features/methodModels/editModels/types';
import addModels from './features/methodModels/addModels';
import { AddModelsState } from './features/methodModels/addModels/types';
import { DeleteModelsState } from './features/methodModels/deleteModels/types';
import deleteModels from './features/methodModels/deleteModels';
import { OneModelsState } from './features/methodModels/oneModels/types';
import oneModels from './features/methodModels/oneModels';
import { AddImagesState } from './features/fs/addImages/types';
import addImages from './features/fs/addImages';
import { DeleteImagesState } from './features/fs/deleteImages/types';
import deleteImages from './features/fs/deleteImages';
import { IUserInitState } from './features/userInit/types';
import userInit from './features/userInit';
import { AllUsersState } from './features/users/allUsers/types';
import allUsers from './features/users/allUsers';
import { CurrentUsersState } from './features/users/currentUsers/types';
import currentUsers from './features/users/currentUsers';
import { ListHistoryState } from './features/methodModels/listHistory/types';
import listHistory from './features/methodModels/listHistory';
import { AddHistoryModelsState } from './features/methodModels/addHistoryModels/types';
import addHistoryModels from './features/methodModels/addHistoryModels';
import { RunModelsState } from './features/methodModels/runModels/types';
import runModels from './features/methodModels/runModels';
import { IJournalState } from './features/journal/types';
import journal from './features/journal';
import allUsersAdministration from './features/administration/allUsersAdministration';
import { AllUsersAdministrationState } from './features/administration/allUsersAdministration/types';

export interface State {
  infoUser: InfoUserState;
  initilizationKeycloak: IInitKeycloakState;
  allModels: AllModalsState;
  editModels: EditModelsState;
  addModels: AddModelsState;
  deleteModels: DeleteModelsState;
  oneModels: OneModelsState;
  addImages: AddImagesState;
  deleteImages: DeleteImagesState;
  userInit: IUserInitState;
  allUsers: AllUsersState;
  currentUsers: CurrentUsersState;
  listHistory: ListHistoryState;
  addHistoryModels: AddHistoryModelsState;
  runModels: RunModelsState;
  journal: IJournalState;
  allUsersAdministration: AllUsersAdministrationState;
}

export default combineReducers({
  router: createRouterReducer(browserHistory),
  infoUser,
  initilizationKeycloak,
  allModels,
  editModels,
  addModels,
  deleteModels,
  oneModels,
  addImages,
  deleteImages,
  userInit,
  allUsers,
  currentUsers,
  listHistory,
  addHistoryModels,
  runModels,
  journal,
  allUsersAdministration,
});
